import type { DefaultLayoutProps } from './types/default-layout.props';

export const DefaultLayout = ({ children, footer, header }: DefaultLayoutProps) => {
  return (
    <>
      {header}
      {children}
      {footer}
    </>
  );
};
